exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p[data-v-b77c9864]{position:relative;padding:0 1.125rem;margin-top:5px;font-size:1rem;color:#6e6e6e}p span[data-v-b77c9864]{font-style:oblique}p.error[data-v-b77c9864]{color:#c52d00}", ""]);

// exports
